export default "__VITE_ASSET__Cg$pm8FM__"